const key = 10;

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href^="mailto:"]')
        .forEach((element) => {
            const href = element.getAttribute('href');

            if (!href.includes('@')) {
                const encodedMail = href.split('mailto:')[1];
                const decodedHref = 'mailto:' + decode(encodedMail);

                element.setAttribute('href', decodedHref);
                const decodedTextContent = decode(element.textContent);
                if (decodedTextContent.includes('@')) {
                    element.textContent = decodedTextContent;
                }
            }
        });
});

function decode(input) {
    let output = '';

    for (let i = 0; i < input.length; i += 2) {
        const hexInput = toHex(input, i);
        const hexOutput = hexInput ^ key;

        output += String.fromCharCode(hexOutput);
    }

    return output;
}

function toHex(text, i) {
    const sequence = text.slice(i, i+2);

    return parseInt(sequence, 16);
}